import { IMsrpDiscount } from '../../../services/discounts/DiscountsService';
import { Action } from '../../../types/Action';
import {
  SET_COPY_DISCOUNTS,
  SET_IS_LOYALTY_DATA_UPDATED,
  SET_LOYALTY_MSRP_DISCOUNTS,
  SET_OFFER_FILTER,
  SET_SELECTED_TAB,
  UPDATED_LOYALTY_MSRP_DISCOUNTS,
  UPDATED_OFFER_FILTER,
} from './offerManagerActionTypes';

interface OfferManagerState {
  loyaltyDiscounts: IMsrpDiscount[];
  isLoyaltyDataUpdated: boolean;
  updatedLoyaltyData: IMsrpDiscount[];
  offerFilter: { year: number[]; model: string[]; trim: string[] };
  updatedOfferFilter: { year: number[]; model: string[]; trim: string[] };
  copyDiscounts: boolean;
  selectedTab: string;
}

export const initialOfferManagerState: OfferManagerState = {
  loyaltyDiscounts: [],
  isLoyaltyDataUpdated: false,
  updatedLoyaltyData: [],
  offerFilter: { year: [], model: [], trim: [] },
  updatedOfferFilter: { year: [], model: [], trim: [] },
  copyDiscounts: false,
  selectedTab: 'loyalty-msrps-discounts',
};

export const offerManagerReducer = (
  state = initialOfferManagerState,
  action: Action,
): OfferManagerState => {
  switch (action.type) {
    case SET_LOYALTY_MSRP_DISCOUNTS:
      return {
        ...state,
        loyaltyDiscounts: action.payload,
      };
    case SET_IS_LOYALTY_DATA_UPDATED:
      return {
        ...state,
        isLoyaltyDataUpdated: action.payload,
      };
    case UPDATED_LOYALTY_MSRP_DISCOUNTS:
      return {
        ...state,
        updatedLoyaltyData: action.payload,
      };
    case SET_OFFER_FILTER:
      return {
        ...state,
        offerFilter: action.payload,
      };
    case UPDATED_OFFER_FILTER:
      return {
        ...state,
        updatedOfferFilter: action.payload,
      };
    case SET_COPY_DISCOUNTS:
      return {
        ...state,
        copyDiscounts: action.payload,
      };
    case SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    default:
      return state;
  }
};
